var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80862 16H9.19141V9.1875H15.4844V6.8125H9.19141V0H6.80862V6.8125H0.515625V9.1875H6.80862V16Z",
    fill: "#668BA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusDisabled);
export default __webpack_public_path__ + "static/media/plus-disabled.d9ee49a67b199774a33a35b60432e26f.svg";
export { ForwardRef as ReactComponent };